export const baseURL = "https://admin.famychat.com/";
export const key = "heb4l#2(sh+dy548d%8+4!airq#9q";
export const projectName = "Famy Chat";